/**
 * Alerts API — the open/closed list, the bell's counts, resolve and dismiss.
 */

import type { AlertCounts, AlertSeverity, AlertStatus, AlertType, AlertView, PageResult } from '@nord-living/shared';

import api from '@/services/api';

export interface AlertListParams {
  status?: AlertStatus;
  /** One severity, or several (sent as a comma list). */
  severity?: AlertSeverity | AlertSeverity[];
  type?: AlertType;
  page?: number;
  limit?: number;
}

export type AlertAction = 'resolve' | 'dismiss';

type Wrapped<T> = { data: T };
const unwrap = <T>(res: { data: Wrapped<T> }) => res.data.data;

const toParams = ({ severity, ...rest }: AlertListParams) => ({
  ...rest,
  ...(severity ? { severity: Array.isArray(severity) ? severity.join(',') : severity } : {}),
});

export const listAlerts = (params: AlertListParams) => api.get<Wrapped<PageResult<AlertView>>>('/alerts', { params: toParams(params) }).then(unwrap);
export const getAlertCounts = () => api.get<Wrapped<AlertCounts>>('/alerts/count').then(unwrap);
export const closeAlert = (id: string, action: AlertAction) => api.post<Wrapped<AlertView>>(`/alerts/${id}/${action}`).then(unwrap);
